<script lang="ts" setup>
import type { ICard } from '~/components/entity/card'
const props = defineProps<{
  card: ICard
}>()
const activeTypes = computed(() =>
  Object.keys(props.card.type).filter((key) => props.card.type[key])
)
</script>

<template>
  <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 md:gap-2">
    <div v-if="props.card && props.card.organization.url">
      <div class="SecondaryTextHeadings">{{ $t('common.bank') }}</div>
      <div class="font-semibold">
        <NuxtLinkLocale
          :to="props.card.organization.url"
          :aria-label="`${$t('common.more_about')} ${props.card.organization.title}`"
          class="text-blue-600 hover:underline"
        >
          {{ props.card.organization.title }}
        </NuxtLinkLocale>
      </div>
    </div>
    <div v-if="props.card && activeTypes">
      <div class="SecondaryTextHeadings">{{ $t('common.type') }}</div>
      <div class="font-semibold">
        {{
          activeTypes
            .map((type) => (type === 'debit' ? $t('common.debit') : $t('common.credit_card')))
            .join(', ')
        }}
      </div>
    </div>

    <div v-if="props.card && props.card.system">
      <div class="SecondaryTextHeadings">
        {{ $t('widget.card_page.info_items.payment_system') }}
      </div>
      <div class="font-semibold">
        <div>
          {{ props.card.system.title || $t('widget.card_page.info_items.not_specified') }}
          <span
            v-if="Object.keys(props.card.system.variants ?? {}).filter((k) => props.card.system.variants[k]).length"
            class="capitalize"
          >
            &mdash;
            {{
              Object.keys(props.card.system.variants)
                .filter((key) => props.card.system.variants[key])
                .join(', ')
            }}
          </span>
        </div>
      </div>
    </div>

    <div v-if="props.card && props.card.interest_rate">
      <div class="SecondaryTextHeadings">{{ $t('widget.card_page.info_items.interest_rate') }}</div>
      <div class="font-semibold" v-html="`${props.card.interest_rate}%`" />
    </div>

    <div v-if="props.card && props.card.card_interest_rate">
      <div class="SecondaryTextHeadings">
        {{ $t('widget.card_page.info_items.card_interest_rate') }}
      </div>
      <div class="font-semibold" v-html="`${props.card.card_interest_rate}`" />
    </div>

    <div v-if="props.card && props.card.grace_period">
      <div class="SecondaryTextHeadings">{{ $t('widget.card_page.info_items.grace_period') }}</div>
      <div class="font-semibold" v-html="`${props.card.grace_period}`" />
    </div>
  </div>
</template>
